<div class="custom-security-link">
    <a [routerLink]="['/voice-tree-list']">Call Tree List</a>
</div>
<div class="margin-all-area">
    <div class="tag-management-panel">
        <div class="wraper-main-section">
            <div class="global-card-section">
                <div class="global-header-section">
                    <div class="svg-icon-panel"><img src="../../../../assets/btnVoiceCall.svg" class="mr-1" />Call Tree</div>
                    <div class="header-button-panel">
                        <div class="button-wrapper" *ngIf="saveAsID == 0">
                            <button *ngIf="voiceTree && isViewMode && isAddOptionVisible" class="icon-btn" type="button" matTooltip="Edit" (click)="edit(); isViewMode = false;">
                                <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                                <span class="btn-text">Edit</span>
                            </button>
                            <button *ngIf="voiceTree && isViewMode" class="icon-btn" type="button" matTooltip="Save As" (click)="saveAs()">
                                <i class="fa fa-save" aria-hidden="true"></i>
                                <span class="btn-text">Save As</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isConfirmed && message" [ngClass]="'alert alert-panel' + messageType" [innerHTML]="message"></div>
                <div class="global-body-section">
                    <form [formGroup]="voiceTreeForm">
                        <div class="align-top-style">
                            <div class="wraper-body-panel">
                                <div class="wraper-body-left">
                                    <div class="company-2d-alert mb-2" *ngIf="isConfirmed">
                                        <span>Please confirm this action.</span>
                                    </div>
                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label">Name</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode && saveAsID == 0">{{voiceTree?.name}}</span>
                                                    <input *ngIf="!isViewMode || saveAsID > 0" type="text" class="form-control" id="shortDesc" name="Name" formControlName="name" />
                                                    <div *ngIf="voiceTreeForm.get('name')?.touched && voiceTreeForm.get('name')?.invalid">
                                                        <small class="text-danger" *ngIf="voiceTreeForm.get('name')?.errors?.['required']"> Please enter a name. </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label" for=""> Greeting Script</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode">{{voiceTree?.greetingScript}}</span>
                                                    <textarea *ngIf="!isViewMode" class="form-control" name="greetingScript" formControlName="greetingScript" maxlength="160"
                                                              rows="2"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label" for=""> Greeting Recording</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode">{{getGreetingRecName(voiceTree?.greetingVRID)}}</span>
                                                    <select *ngIf="!isViewMode" class="form-control" formControlName="greetingVRID">
                                                        <option [value]="0">-Select One-</option>
                                                        <option *ngFor="let item of vrDDList" [value]="item.id">{{item.text}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label" for="Record Call"> Record Call</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode" [ngClass]="{ 'smallgreen': voiceTree?.isRecorded, 'smallred': !voiceTree?.isRecorded }">
                                                        {{voiceTree?.isRecorded ? 'Active' : 'Not-Active' }}
                                                    </span>
                                                    <mat-checkbox formControlName="isRecorded" *ngIf="!isViewMode"></mat-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label" for="Record Call"> Active</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode" [ngClass]="{ 'smallgreen': voiceTree?.isActive, 'smallred': !voiceTree?.isActive }">
                                                        {{voiceTree?.isActive ? 'Active' : 'Not-Active'}}
                                                    </span>
                                                    <mat-checkbox formControlName="isActive" *ngIf="!isViewMode"></mat-checkbox>

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label" for=""> </span>
                                            </div>

                                            <div class="cards-colunm-right">
                                                <div class="w-100" *ngIf="!isConfirmed && (!isViewMode || saveAsID > 0); else viewButtons">
                                                    <button class="btn btn-primary" *ngIf="!isConfirmed" (click)="save()">Save</button>
                                                    <button class="btn btn-cancel" (click)="cancel(); ">Cancel</button>
                                                    <button class="btn btn-danger" *ngIf="!isConfirmed && voiceTreeID > 0 && saveAsID == 0" (click)="delete();isConfirmed = true;isViewMode = true; ">Delete</button>
                                                </div>
                                                <ng-template #viewButtons>
                                                    <div class="w-100">
                                                        <button class="btn btn-danger" *ngIf="isConfirmed" (click)="VoiceTreeDelete()">Confirm</button>
                                                        <button class="btn btn-cancel" *ngIf="isConfirmed" (click)="cancel();">Cancel</button>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <div>
                                                    <span class="control-label" for="DialOptions"> Dial Options</span>
                                                    <div class="mt-1">
                                                        <br />
                                                        <button *ngIf="!isViewMode && isAddOptionVisible && voiceTreeID > 0" class="btn btn-primary" title="Click to add a dial option" (click)="onAddClick(true)"> Add </button>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="vt-option-wrapper">
                                                    <div class="vt-option-left">
                                                        <div class="message-info" *ngIf="!voiceTreeOptionList || voiceTreeOptionList?.length == 0">NO options exists.</div>
                                                        <app-voice-tree-option-list *ngIf="voiceTreeOptionList && voiceTreeOptionList?.length > 0 && saveAsID == 0" [voiceTreeId]="voiceTreeID" [voiceTreeOptionList]="voiceTreeOptionList"
                                                                                    (rowSelected)="loadOptionDetails($event)" ></app-voice-tree-option-list>
                                                    </div>
                                                    <div class="vt-option-right">
                                                        <app-voice-tree-option [hidden]="!isShowVTOption" [voiceTreeId]="voiceTreeID" [voiceTreeOptionId]="voiceTreeOptionID" [selectedOption]="selectedOption"
                                                                               (optionSaved)="getVTOptionList()" (optionDeleted)="onOptionDeleted()" [isViewMode]="isViewMode" [isEditMode]="isEditMode" (closeVoiceOption)="closeOption()"> </app-voice-tree-option>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="global-body-section" *ngIf="voiceTreeID > 0">
                        <div class="align-top-style">
                            <div class="wraper-body-panel">
                                <div class="wraper-body-left">
                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label"> Call Tree Numbers</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="width-50">
                                                    <div class="customer-name" *ngIf="!isViewMode">
                                                        <kendo-multicolumncombobox [data]="assignNumbersList"
                                                                                   textField="desc"
                                                                                   valueField="longCodeNumber"
                                                                                   [(ngModel)]="selectedAssignNumber"
                                                                                   [ngModelOptions]="{standalone:true}"
                                                                                   (selectionChange)="onAssignNumberChange($event)"
                                                                                   placeholder=" ">

                                                            <kendo-combobox-column field="desc" title="Description" [width]="200">
                                                            </kendo-combobox-column>
                                                            <kendo-combobox-column field="longCodeNumber" title="Number" [width]="200">
                                                            </kendo-combobox-column>

                                                        </kendo-multicolumncombobox>

                                                    </div>
                                                    <br />
                                                    <div *ngIf="vtNumberListSource && vtNumberListSource?.data?.length > 0 && saveAsID == 0">
                                                        <table mat-table [dataSource]="vtNumberListSource" class="mat-elevation-z8" matSort (matSortChange)="_localService.setSortState($event, 'view_voiceTreeList_grid')">
                                                            <ng-container matColumnDef="rowNo">
                                                                <th mat-header-cell *matHeaderCellDef>  </th>
                                                                <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="longCodeNumber">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Number </th>
                                                                <td mat-cell *matCellDef="let dataItem"> {{ dataItem.longCodeNumber }} </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="description">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
                                                                <td mat-cell *matCellDef="let dataItem"> {{ dataItem.description }} </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="delete">
                                                                <th mat-header-cell *matHeaderCellDef>  </th>
                                                                <td mat-cell *matCellDef="let dataItem">
                                                                    <button mat-icon-button color="warn" (click)="deleteNumber(dataItem)">
                                                                        <i class="fa fa-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </ng-container>

                                                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
